import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const DEFAULT_NUMERIC_VALUE = 0;

@Injectable({
  providedIn: 'root',
})
export class DashboardState {
  private currentUser$ = new BehaviorSubject<boolean>(false);
  private balance$ = new BehaviorSubject<number>(undefined);
  private score$ = new BehaviorSubject<number>(DEFAULT_NUMERIC_VALUE);

  getCurrentUser$() {
    return this.currentUser$.asObservable();
  }

  getBalance$() {
    return this.balance$.asObservable();
  }

  getScore$() {
    return this.score$.asObservable();
  }

  setCurrentUser$(currentUser) {
    this.currentUser$.next(currentUser);
  }

  setBalance$(balance) {
    this.balance$.next(balance);
  }

  setScore$(score) {
    this.score$.next(score);
  }
}
